<style lang="scss" scoped>
.product-rows {
    .product-row {
        display: flex;
        margin: 0 -8px -32px -8px;
        flex-wrap: wrap;

        @media screen and (min-width: 1024px) {
            margin: 0 -16px -32px -16px;
        }

        .card-column {
            padding: 0 8px;
            width: 50%;
            display: flex;

            ::v-deep .product-card {
                margin-bottom: 32px;
                flex: 1;
            }

            @media screen and (min-width: 768px) {
                width: percentage(1/3);
            }

            @media screen and (min-width: 1024px) {
                padding: 0 16px;
                width: 25%;
            }
        }
    }

    .slot-wrapper {
        margin: 40px 0;
        padding: 16px 0;
        border-top: 1px solid #dedfe3;
        border-bottom: 1px solid #dedfe3;

        @media screen and (min-width: 768px) {
            margin: 60px 0;
        }

        ::v-deep > .flex {
            & > div {
                @media screen and (max-width: 1023.98px) {
                    display: none;

                    &:first-child {
                        display: flex;
                        margin-bottom: 0;
                    }
                }
            }
        }
    }
}
</style>

<template>
    <div class="product-rows">
        <div class="product-row">
            <div class="card-column" v-for="product in productsAboveSlot" :key="product.id">
                <product-card :variants="product.variants" :title="product.name" :description="product.introduction && product.introduction != '' ? product.introduction : product.description" :media="product.media" :is-top="product.is_top" :link="`/product/${product.slug}`"></product-card>
            </div>
        </div>
        <div class="slot-wrapper" v-if="productsAboveSlot.length > 0" v-cloak>
            <slot></slot>
        </div>
        <div class="product-row" v-if="productsBelowSlot.length > 0">
            <div class="card-column" v-for="product in productsBelowSlot" :key="product.id">
                <product-card :variants="product.variants" :title="product.name" :description="product.introduction && product.introduction != '' ? product.introduction : product.description" :media="product.media" :is-top="product.is_top" :link="`/product/${product.slug}`"></product-card>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "Ui.ProductRows",

    props: {
        products: {
            type: Array,
            required: true
        }
    },

    computed: {
        productsAboveSlot() {
            let perRow = this.$root.screen.md && !this.$root.screen.lg ? 3 : 4;
            return this.products.slice(0, perRow);
        },

        productsBelowSlot() {
            let perRow = this.$root.screen.md && !this.$root.screen.lg ? 3 : 4;
            return this.products.slice(perRow, this.products.length);
        }
    }
}
</script>